export default {
    disclaimer: {
        label_default: "I acknowledge and agree that the items I am ordering / receiving are DXC property to be used for DXC work related activities. Also, if the address I provided is incorrect or unconfirmed and my order is not delivered, DXC will incur restocking fees.",
        errors: {
            required: "Please click acknowledge statement to order"
        }
    },
    preferred_delivery_date: {
        "Preferred Delivery Date": "Preferred Delivery Date"
    },
    order_note: {
        label: "Order Note",
        placeholder: "Note to approver on this order",
        errors: {
            required: "Order Note is Required"
        }
    },
    send_emails_to_oobo_orderer: {
        "OOBO": "Notify me with updates on this order"
    },
    info: {
        label: "Note: To ensure successfully delivery of your items please enter your complete address details including any special instructions. Please double check PIN and Phone  number are complete and correct before submitting your order.  Once submitted, details cannot be changed and orders cannot be canceled."
    },
    info_EGY: {
        label: "Delivery is not available in rural areas.  If your address is outside a metro area, your order will be shipped to the local DXC office. You will be responsible for picking your order up from the office once it arrives. You will be alerted when your order is ready for pickup. If for some reason you are not able to pick up your order from the DXC office, please submit a support ticket before submitting your order."
    },
    shipping_next_quarter_message: {
        label: "Orders may be delayed during quarter end processing.  Your order has been received and will be fulfilled as soon as possible"
    }
}